import React from "react";

import "./Logo.scss";

export const Logo = () => {
  return (
    <div className="logo__wrapper">
      <img className="logo__image" src="images/logo_header.svg" alt="Logo" />
    </div>
  );
};
